import { Injectable } from '@angular/core';

declare var introJs: any;
@Injectable()
export class IntroService {
    intro = introJs();

    constructor() {
        this.intro.setOptions({
            //showBullets: false,
            //showProgress: true,
            skipLabel: 'Close',
            doneLabel: 'Close',
            prevLabel: 'Back',
            nextLabel: 'Continue',
            hidePrev: true,
            hideNext: true,
            tooltipClass: "myToolTip",
            exitOnEsc: true,
            exitOnOverlayClick: true,
            showStepNumbers: false,
            keyboardNavigation: false,
            showButtons: true,
            showBullets: true,
            showProgress: false,
            disableInteraction: false,
            overlayOpacity: 0
        });
    }

    introJS() {
        return this.intro;
    }

    setHomeOptions() {
        let footer = '<p style="margin-bottom: 0; margin-top: 1.5rem; font-variant: petite-caps; text-align: center;">Click Continue to go to the next screen. Close to exit Help.</p>';

        this.intro.setOptions({
            steps: [
                {
                    intro: `<p><b>Getting Started</b></p>
					<p>The first steps in placing an order are:</p>
					<ol style="margin-left: -24px;">
						<li>Find a location using the search box to the left.</li>
						<li>Set or select the geometry using one of the drawing tools to the right.</li>
					</ol>
					<p>When done, click&nbsp;
					<strong style="font-size: 10px; background-color: #002d72; color: white; font-weight: 400; border-radius: 5px; padding: 4px 12px;">NEXT<i class="fa fa-angle-double-right"></i></strong>&nbsp;
					to proceed to choose a Report Package or Products.</p>`+ footer
                },
                {
                    element: '#pac-input',
                    intro: `<p><b>Search for a Location</b></p>
					<p>There are two ways to search for a location:</p>
					<ol>
						<li>Enter an address in the search box to the left and select a matching location from the list.</li>
						<li>Input latitude and longitude in decimal, degree format (e.g. 40.68487229999999, -73.97909600000003).</li>
					</ol>`+ footer
                },
                {
                    intro: `<p><b>Set Geometry</b></p>
					<p>After locating an address, set or select geometry in one of the ways below:</p>
					<div style="display: block; height: 30px;">
  					<div style="display: inline-block;">
					    1. Double-click on a <strong>Tax Parcel</strong> and
					    click <strong style="background-color: #c2d63e; color: white; font-weight: 400; border-radius: 5px; padding: 2px 6px;">Select Geometry</strong>
						</div>
					</div>
					<div style="display: block; height: 48px;">
  					<div style="display: block;">
							<div style="float: left; padding-right: 3px; padding-top: 6px">2.</div>
							<img src="assets/images/help_polygon.png" class="help_image"/>
							<img src="assets/images/help_polyline.png" class="help_image"/>
							<img src="assets/images/help_marker.png" class="help_image"/>
							Use one of the drawing tools to draw a polygon (property boundary), polyline (corridor) or set the point
						</div>
					</div>
					<div style="display: block; height: 48px;">
  					<div style="display: block;">
							<span style="float: left; padding-right: 3px; padding-top: 8px">3.</span>
							<img src="assets/images/help_upload.png"  class="help_image"/>
							<span style="float: left; padding-right: 3px; padding-top: 8px">Upload files</span>
						</div>
					</div>
					<div style="display: block; height: 48px;">
  					<div style="display: block;">
							<span style="float: left; padding-right: 3px; padding-top: 8px">To clear the geometry, use the trash icon</span>
							<img src="assets/images/help_trash.png"  class="help_image"/>
						</div>
					</div>`+ footer,
                    tooltipClass: "menuTooTip"
                },
                {
                    element: 'section',
                    intro: `<p><b>Tax Parcel</b></p>
					<ul>
						<li>Toggle the parcel layer on or off by clicking the <img src="assets/images/help_parcel.png" class="help_inline"/> icon on the toolbar</li>
						<li>Parcels are displayed in orange</li>
						<li>Double click a parcel on or near your property to view more details</li>
						<li>Click <strong style="background-color: #c2d63e; color: white; font-weight: 400; border-radius: 5px; padding: 2px 6px;">Select Geometry</strong> to select that tax parcel for your order</li>
					</ul>`+ footer,
                    tooltipClass: "introToolTip",
                },
                {
                    element: '#gmdm-toolbar',
                    intro: `<p><b>Drawing Tools</b></p>
					<p>To draw a polygon, polyline or set the point, click the symbol and the symbol will turn to grey</p>`+ footer
                },
                {
                    element: 'section',
                    intro: `<p><b>Polygon / Polyline</b></p>
					<ul>
						<li>Position your starting point and click. Repeat to draw additional points</li>
						<li>When done, double click to set the end point</li>
						<li>Click the trash can <img src="assets/images/help_trash.png" class="help_inline"/>to start over again</li>
						<li>For polygon <img src="assets/images/help_polygon.png" class="help_inline"/>, the tool will join your last point to the first point to make a polygon when they are not connected.</li>
						<li>You may adjust the drawing by dragging the little white circle on the perimeter</li>
					</ul>`+ footer,
                    tooltipClass: "introToolTip",
                },
                {
                    element: '#button-upload',
                    intro: `<p><b>Upload File</b></p>
					<p>Click the  <img src="assets/images/help_upload.png" class="help_inline"/> icon on the toolbar to trigger file upload</p>`+ footer
                },
                {
                    element: 'section',
                    intro: `<p><b>Upload File</b></p>
					<ul>
						<li>The following file types are supported:<br />
						kml, kmz, shapefiles (shp, tab, shx) with optional prj file<br />
						.xls .doc .docx .pdf .dbf  .tab .dat .map .tiff .jpeg .gif .bmp .png .zip .rar</li>
						<li>File upload allows a single file while 3 files are required for shapefile type (a zip file is required)</li>
						<li>Please select &ldquo;.shp&rdquo; from the dropdown if the zip file contains .shp file
						<li>For KML, KMZ and shapefile file types, the corresponding geometry will be displayed on the web order form map; all other file formats will be drawn by ERIS after the order is placed</li>
						<li>Any file missing geometry information will not be allowed to proceed to next step</li>
					</ul>`+ footer,
                    tooltipClass: "introToolTip",
                }
            ]
        });
    }

    setPackageOptions() {
        this.intro.setOptions({
            steps: [
                {
                    intro: `<p><b>Select Packages / Products</b></p>
					<ol>
						<li>You may select custom packages or ERIS standard packages through the <strong>Packages</strong> tab; or select individual products through the <strong>Products</strong> tab</li>
						<li>Hover over individual package for detailed descriptions</li>
						<li>Additional information may be required for some products</li>
						<li>Associated products will be checked when they are part of your selected package</li>
						<li>All selected products and input details are displayed on the order summary on the right for reference</li>
					</ol>`,
                    tooltipClass: "menuTooTip"
                },
                {
                    element: '#packageTab',
                    intro: `<p><b>PACKAGES</b></p>
					<p>Have both custom packages and ERIS standard packages for your selection</p>`
                },
                {
                    element: '#productTab',
                    intro: `<p><b>PRODUCTS</b></p>
					<p>Non-package products that you may order separately or add to a package</p>`
                }
            ]
        });
    }

    setSummaryOptions() {
        this.intro.setOptions({
            steps: [
                {
                    intro: `<p><b>Project Summary</b></p>
					<ul>
						<li>Enter any project information you have and Project Name is the only required field</li>
						<li>Enter a P.O. / Project Number to be referenced on reports and invoices</li>
						<li>Click&nbsp;
						<strong style="font-size: 10px; background-color: #002d72; color: white; font-weight: 400; border-radius: 5px; padding: 4px 12px;">ADD TO CART<i class="fa fa-angle-double-right"></i></strong>&nbsp;
					 to proceed to next step</li>
					</ul>`,
                    tooltipClass: "menuTooTip"
                }
            ]
        });
    }

    setCheckoutOptions() {
        this.intro.setOptions({
            steps: [
                {
                    intro: `<p><b>Checkout</b></p>
					<p>Review all orders in the shopping cart and decide to proceed to Check out / Continue Shopping</p>`,
                    tooltipClass: "menuTooTip"
                },
                {
                    element: '#my_cart',
                    intro: `<p><b>My Cart</b></p>
					<ul>
						<li>Review all orders in shopping cart and you may edit or remove any item in the cart</li>
						<li>Edit will bring you back to packages/products selection page</li>
					</ul>`
                },
                {
                    element: '#continue_shopping',
                    intro: `<p><b>Continue Shopping</b></p>
					<p>This will take you back to property location page to start a new order</p>`
                },
                {
                    element: '#place_order',
                    intro: `<p><b>Place Order</b></p>
					<ul>
						<li>When everything is fine, you may proceed to checkout</li>
						<li>Please select your payment method (invoice vs credit card)</li>
						<li>Please read Legal Terms and check &lsquo;Agree to Legal & Pay&rsquo;  before clicking&nbsp;
							<strong style="font-size: 10px; background-color: #002d72; color: white; font-weight: 400; border-radius: 5px; padding: 4px 12px;">PLACE ORDER</strong></li>
					</ul>`
                }
            ]
        });
    }
}